import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loginIsLoading: false,
  isUpdateLoading: false,
  isLoading: false,
  id: null,
  supplierId: null,
  firstName: null,
  lastName: null,
  name: null,
  initials: null,
  email: null,
  role: null,
  status: null,
  isOnPremise: null,
  isRetail: null,
  currentChannel: null,
  sessionExpire: null,
  timeOutSet: false,
  territories: [],
  states: [],
  currentTerritory: null,
  favoriteItemIds: [],
  logInError: null,
  error: null,
};

const loadingFailed = (state, action) => {
  const { error } = action.payload;
  state.isLoading = false;
  state.loginIsLoading = false;
  state.error = error;
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setIsLoading(state) {
      state.isLoading = true;
    },
    setUpdateLoading(state) {
      state.isUpdateLoading = true;
    },
    getUserSuccess(state, action) {
      const { user } = action.payload;
      state.id = user.id;
      state.supplierId = user.supplierId;
      state.name = user.name;
      state.firstName = user.firstName;
      state.lastName = user.lastName;
      state.initials = user.initials;
      state.email = user.email;
      state.role = user.role;
      state.status = user.status;
      state.isOnPremise = user.isOnPremise;
      state.isRetail = user.isRetail;
      state.currentChannel = state.currentChannel
        ? state.currentChannel
        : user.currentChannel;
      state.territories = [...user.territories];
      state.states = user.states.length > 0 ? [...user.states] : [];
      state.currentTerritory = state.currentTerritory
        ? state.currentTerritory
        : user.currentTerritory;
      state.favoriteItemIds = user.favoriteItemIds;
      state.isLoading = false;
      state.logInError = null;
      state.error = null;
    },
    updateCurrentTerritory(state, action) {
      const { territory } = action.payload;
      state.currentTerritory = territory;
    },
    updateCurrentChannel(state, action) {
      const { channel } = action.payload;
      state.currentChannel = channel;
    },
    setFailure: loadingFailed,
  },
});

export const {
  setIsLoading,
  setUpdateLoading,
  getUserSuccess,
  updateCurrentTerritory,
  updateCurrentChannel,
  setFailure,
} = userSlice.actions;

export default userSlice.reducer;
